import { lazy, Suspense, type ReactNode } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import NotFound from "@/pages/NotFound";

// Every secondary page ships as its own chunk and is only requested
// when the route is actually visited.
const KiPage = lazy(() => import("@/pages/ki/page"));
const KarrierePage = lazy(() => import("@/pages/karriere/page"));
const FischePage = lazy(() => import("@/pages/fische/page"));
const Impressum = lazy(() => import("@/pages/impressum/page"));
const Datenschutz = lazy(() => import("@/pages/datenschutz/page"));
const Haftungsausschluss = lazy(() => import("@/pages/haftungsausschluss/page"));

/**
 * Minimal, invisible placeholder while a page chunk loads.
 * Keeps the paper-white backdrop so there is no dark flash.
 */
function RouteFallback() {
  return <div className="min-h-screen w-full bg-white" aria-busy="true" />;
}

function Page({ children }: { children: ReactNode }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ki",
    element: (
      <Page>
        <KiPage />
      </Page>
    ),
  },
  {
    path: "/karriere",
    element: (
      <Page>
        <KarrierePage />
      </Page>
    ),
  },
  {
    path: "/projekte",
    element: (
      <Page>
        <FischePage />
      </Page>
    ),
  },
  {
    // Old address kept alive so existing links and bookmarks still land right.
    path: "/fische",
    element: <Navigate to="/projekte" replace />,
  },
  {
    path: "/impressum",
    element: (
      <Page>
        <Impressum />
      </Page>
    ),
  },
  {
    path: "/datenschutz",
    element: (
      <Page>
        <Datenschutz />
      </Page>
    ),
  },
  {
    path: "/haftungsausschluss",
    element: (
      <Page>
        <Haftungsausschluss />
      </Page>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;